import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Col, Badge, Spinner, Modal } from 'react-bootstrap';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { CME_DIEU_DUONG_API, FILE_MANAGER_API, KYSO_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { Get, Post, PostFormData } from '../../../../utils/httpProvider';
import moment from 'moment';
import { AsyncPaginate } from 'react-select-async-paginate';
import { objectChuKyBienBan, objectLoaiKy, styleSelectDefault } from '../../../../utils/define';
import { Document, Page } from 'react-pdf';
import { exportToBienBan } from './cmeDieuDuongExportHelper';
import DatePicker from 'react-datepicker';

const TRANG_THAI_BIEN_BAN = {
    0: { label: 'Nháp', variant: 'secondary' },
    1: { label: 'Hoàn thành', variant: 'success' },
};

const CMEBienBanFormTab = ({ eventData }) => {
    const queryClient = useQueryClient();

    // =========================================================
    // STATE
    // =========================================================
    const [thanhPhan, setThanhPhan] = useState('');
    const [thuKy, setThuKy] = useState('');
    const [thoiGianBatDau, setThoiGianBatDau] = useState('');
    const [thoiGianKetThuc, setThoiGianKetThuc] = useState('');
    const [diaDiem, setDiaDiem] = useState('');
    const [chuTri, setChuTri] = useState('');
    const [tenBaoCao, setTenBaoCao] = useState('');
    const [baoCaoVien, setBaoCaoVien] = useState('');
    const [ketLuanThongNhat, setKetLuanThongNhat] = useState('');
    const [ketLuanTrienKhai, setKetLuanTrienKhai] = useState('');
    const [trangThaiBienBan, setTrangThaiBienBan] = useState(0);
    const [yKiens, setYKiens] = useState([{ nguoiDongGop: '', noiDung: '' }]);
    const [docxFileId, setDocxFileId] = useState(null);
    const [docxFilePath, setDocxFilePath] = useState('');
    const [filePathAbsolute, setFilePathAbsolute] = useState('');
    const [downloadUrl, setDownloadUrl] = useState('');
    const [signedFields, setSignedFields] = useState([]);
    const [bienBanUrl, setBienBanUrl] = useState('');
    const [isExporting, setIsExporting] = useState(false);
    const [isResettingFile, setIsResettingFile] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [isSigning, setIsSigning] = useState(false);
    const [openSignModal, setOpenSignModal] = useState(false);
    const [openPdfViewer, setOpenPdfViewer] = useState(false);
    const [numPages, setNumPages] = useState(0);
    const [bulkUsername, setBulkUsername] = useState('');
    const [bulkPassword, setBulkPassword] = useState('');
    const [bulkLoaiKy, setBulkLoaiKy] = useState(objectLoaiKy[0]?.value || '');
    const [bulkChuKy, setBulkChuKy] = useState(objectChuKyBienBan[0]?.value || '');

    // =========================================================
    // FETCH DATA
    // =========================================================
    const { data: bienBanData, isLoading } = useQuery(
        ['cmeBienBan', eventData?.id],
        () => Get(`${CME_DIEU_DUONG_API.GET_BIEN_BAN}/${eventData?.id}`),
        { enabled: !!eventData?.id }
    );

    useEffect(() => {
        if (bienBanData && bienBanData.id) {
            setThoiGianBatDau(bienBanData.thoiGianBatDau
                ? moment(bienBanData.thoiGianBatDau).format('YYYY-MM-DDTHH:mm')
                : '');
            setThoiGianKetThuc(bienBanData.thoiGianKetThuc
                ? moment(bienBanData.thoiGianKetThuc).format('YYYY-MM-DDTHH:mm')
                : '');
            setThuKy(bienBanData.thuKy || '');
            setThanhPhan(bienBanData.thanhPhanThamGia || '');
            setDiaDiem(bienBanData.diaDiem || eventData?.diaDiem || '');
            setChuTri(bienBanData.chuTri || eventData?.chuTri || '');
            setTenBaoCao(bienBanData.tenBaoCao || eventData?.tenBaoCao || '');
            setBaoCaoVien(bienBanData.baoCaoVien || eventData?.baoCaoVien || '');
            setKetLuanThongNhat(bienBanData.ketLuanThongNhat || '');
            setKetLuanTrienKhai(bienBanData.ketLuanTrienKhai || '');
            setTrangThaiBienBan(bienBanData.trangThaiBienBan ?? 0);
            setFilePathAbsolute(bienBanData.bienBanFilePathAbsolute || '');
            setDownloadUrl(bienBanData.bienBanDownloadUrl || '');
            setSignedFields(parseSignedFields(bienBanData.bienBanSignedFields));
            setBienBanUrl(bienBanData.bienBanUrl || '');

            try {
                const parsed = JSON.parse(bienBanData.noiDungThaoLuan || '[]');
                setYKiens(parsed.length > 0 ? parsed : [{ nguoiDongGop: '', noiDung: '' }]);
            } catch {
                setYKiens([{ nguoiDongGop: '', noiDung: '' }]);
            }
        } else {
            setThoiGianBatDau('');
            setThoiGianKetThuc('');
            setThuKy('');
            setThanhPhan('');
            setDiaDiem(eventData?.diaDiem || '');
            setChuTri(eventData?.chuTri || '');
            setTenBaoCao(eventData?.tenBaoCao || '');
            setBaoCaoVien(eventData?.baoCaoVien || '');
            setKetLuanThongNhat('');
            setKetLuanTrienKhai('');
            setTrangThaiBienBan(0);
            setFilePathAbsolute('');
            setDownloadUrl('');
            setSignedFields([]);
            setBienBanUrl('');
            setYKiens([{ nguoiDongGop: '', noiDung: '' }]);
        }
    }, [bienBanData, eventData]);

    // =========================================================
    // MUTATION
    // =========================================================
    const saveMutation = useMutation((payload) =>
        Post(CME_DIEU_DUONG_API.UPSERT_BIEN_BAN, null, payload)
    );

    const handleSave = (trangThai) => {
        const validYKiens = yKiens
            .filter(y => y.nguoiDongGop.trim() || y.noiDung.trim())
            .map((y, idx) => ({ stt: idx + 1, nguoiDongGop: y.nguoiDongGop.trim(), noiDung: y.noiDung.trim() }));

        const payload = {
            cMEKhoaDaoTaoDieuDuongId: eventData?.id,
            thoiGianBatDau: thoiGianBatDau ? moment(thoiGianBatDau).format('YYYY-MM-DDTHH:mm:ss') : null,
            thoiGianKetThuc: thoiGianKetThuc ? moment(thoiGianKetThuc).format('YYYY-MM-DDTHH:mm:ss') : null,
            thuKy: thuKy || null,
            thanhPhanThamGia: thanhPhan || null,
            diaDiem: diaDiem || null,
            chuTri: chuTri || null,
            tenBaoCao: tenBaoCao || null,
            baoCaoVien: baoCaoVien || null,
            noiDungThaoLuan: JSON.stringify(validYKiens),
            ketLuanThongNhat: ketLuanThongNhat || null,
            ketLuanTrienKhai: ketLuanTrienKhai || null,
            trangThaiBienBan: trangThai,
        };

        saveMutation.mutate(payload, {
            onSuccess: () => {
                toast.success(trangThai === 1 ? 'Hoàn thành biên bản!' : 'Đã lưu nháp biên bản!');
                queryClient.invalidateQueries(['cmeBienBan', eventData?.id]);
                queryClient.invalidateQueries(['cmeDieuDuongEventsPaging']);
            },
            onError: (err) => {
                toast.error(err?.message || 'Lỗi khi lưu biên bản.');
            }
        });
    };

    const addYKien = () => setYKiens(prev => [...prev, { nguoiDongGop: '', noiDung: '' }]);
    const removeYKien = (idx) => setYKiens(prev => prev.filter((_, i) => i !== idx));
    const updateYKien = (idx, field, value) => {
        setYKiens(prev => prev.map((y, i) => i === idx ? { ...y, [field]: value } : y));
    };

    const trangThaiInfo = TRANG_THAI_BIEN_BAN[trangThaiBienBan] || TRANG_THAI_BIEN_BAN[0];

    const loadOptionsDocxFile = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(FILE_MANAGER_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            IsTemplate: true,
            Keyword: search,
            FileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        const data = res?.data || [];
        return {
            options: data.map(item => ({ label: item.filePath, value: item.id })),
            hasMore: data.length === pageSize,
            additional: { page: page + 1 }
        };
    };

    const parseSignedFields = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value.filter(Boolean);
        return String(value).split(',').map(item => item.trim()).filter(Boolean);
    };

    const getRelativeFilePath = (absolutePath) => {
        if (!absolutePath) return '';
        const normalizedPath = absolutePath.replace(/\\/g, '/');
        const match = normalizedPath.match(/(?:^|\/)(files|fileSign|cachedDocument)\/(.+)$/i);
        return match ? `${match[1]}/${match[2]}` : (normalizedPath.split('/').pop() || normalizedPath);
    };

    const resolvePdfUrl = (url) => {
        if (!url) return '';
        if (/^https?:\/\//i.test(url)) return url;
        return `${BaseGatewayImage}${url.startsWith('/') ? '' : '/'}${url}`;
    };

    const getFileName = (path) => (path || '').split(/[\\/]/).pop() || '';
    const hasAllRequiredSignatures = objectChuKyBienBan.every(item => signedFields.includes(item.value));

    const persistBienBanFileState = async (nextState = {}) => {
        if (!bienBanData?.id) {
            throw new Error('Vui lòng lưu nháp biên bản trước khi thao tác với file.');
        }
        await Post(`${CME_DIEU_DUONG_API.SAVE_BIEN_BAN_FILE_STATE}/${bienBanData.id}`, null, {
            filePathAbsolute: nextState.filePathAbsolute ?? filePathAbsolute,
            downloadUrl: nextState.downloadUrl ?? downloadUrl,
            signedFields: nextState.signedFields ?? signedFields,
            bienBanUrl: nextState.bienBanUrl ?? bienBanUrl
        });
        queryClient.invalidateQueries(['cmeBienBan', eventData?.id]);
    };

    const handleExportBienBan = async () => {
        if (!bienBanData?.id) {
            toast.warning('Vui lòng lưu nháp biên bản trước khi xuất file.');
            return;
        }
        if (!docxFilePath) {
            toast.warning('Vui lòng chọn file mẫu DOCX.');
            return;
        }
        setIsExporting(true);
        try {
            const result = await exportToBienBan([], {
                ...eventData,
                chuTri,
                baoCaoVien,
                diaDiem,
                tenBaoCao,
                thuKy,
                thoiGianBatDau,
                thoiGianKetThuc,
                thanhPhanThamGia: thanhPhan,
                noiDungThaoLuan: JSON.stringify(yKiens),
                ketLuanThongNhat,
                ketLuanTrienKhai
            }, docxFilePath);
            if (!result) return;
            const relativeUrl = getRelativeFilePath(result);
            setFilePathAbsolute(result);
            setDownloadUrl(relativeUrl);
            setSignedFields([]);
            setBienBanUrl('');
            await persistBienBanFileState({ filePathAbsolute: result, downloadUrl: relativeUrl, signedFields: [], bienBanUrl: '' });
        } catch (error) {
            toast.error(error?.message || 'Lỗi khi xuất biên bản.');
        } finally {
            setIsExporting(false);
        }
    };

    const handleOpenSignModal = () => {
        if (!filePathAbsolute) return toast.warning('Vui lòng xuất biên bản trước khi ký.');
        const firstUnsigned = objectChuKyBienBan.find(item => !signedFields.includes(item.value));
        setBulkChuKy(firstUnsigned?.value || objectChuKyBienBan[0]?.value || '');
        setBulkUsername('');
        setBulkPassword('');
        setOpenSignModal(true);
    };

    const handleSign = async () => {
        if (!bulkUsername || !bulkPassword) return toast.warning('Vui lòng nhập username và password.');
        if (signedFields.includes(bulkChuKy)) return toast.warning('Ô ký này đã được ký.');
        const nextSignedFields = [...new Set([...signedFields, bulkChuKy])];
        const isFinalSignature = objectChuKyBienBan.every(item => nextSignedFields.includes(item.value));
        setIsSigning(true);
        try {
            const res = await Post(KYSO_API.KYSO_ONE_FILE_ONE_SIGNATURE, null, {
                userName: bulkUsername,
                password: bulkPassword,
                mid: objectLoaiKy.find(item => item.value == bulkLoaiKy)?.value,
                signatureName: bulkChuKy,
                filePathAbsolute,
                filePath: getRelativeFilePath(filePathAbsolute),
                isFinalSignature
            }, false, false, true);
            if (!res?.success) return toast.error(res?.message || 'Ký số thất bại.');
            setFilePathAbsolute(res.filePathAbsolute);
            setDownloadUrl(res.downloadUrl);
            setSignedFields(nextSignedFields);
            await persistBienBanFileState({ filePathAbsolute: res.filePathAbsolute, downloadUrl: res.downloadUrl, signedFields: nextSignedFields });
            setOpenSignModal(false);
            setOpenPdfViewer(true);
            toast.success(isFinalSignature ? 'Đã ký hoàn tất biên bản.' : 'Ký biên bản thành công.');
        } catch (error) {
            toast.error(error?.message || 'Có lỗi khi ký biên bản.');
        } finally {
            setIsSigning(false);
        }
    };

    const handleUploadBienBan = async () => {
        if (!hasAllRequiredSignatures) return toast.warning('Vui lòng ký đủ Chủ trì và Thư ký.');
        setIsUploadingFile(true);
        try {
            const response = await fetch(resolvePdfUrl(downloadUrl));
            if (!response.ok) throw new Error('Không tải được PDF đã ký.');
            const blob = await response.blob();
            const formData = new FormData();
            formData.append('file', new File([blob], getFileName(downloadUrl) || `bien-ban-${moment().format('YYYYMMDDHHmmss')}.pdf`, { type: blob.type || 'application/pdf' }));
            const res = await PostFormData(FILE_MANAGER_API.UPLOAD, formData);
            const uploaded = Array.isArray(res) ? res[0] : res;
            const fileUrl = uploaded?.filePath || uploaded?.FilePath || uploaded?.path || uploaded?.fileUrl || res?.path || res?.fileUrl;
            if (!fileUrl) throw new Error('Không nhận được đường dẫn file từ Server.');
            setBienBanUrl(fileUrl);
            await persistBienBanFileState({ bienBanUrl: fileUrl });
            toast.success('Đã lưu PDF biên bản ký số.');
        } catch (error) {
            toast.error(error?.message || 'Lỗi khi lưu PDF biên bản.');
        } finally {
            setIsUploadingFile(false);
        }
    };

    const handleResetBienBanFile = async () => {
        if (!window.confirm('Reset sẽ xóa các file biên bản đã xuất/ký. Bạn có chắc chắn?')) return;
        setIsResettingFile(true);
        try {
            await Post(`${CME_DIEU_DUONG_API.RESET_BIEN_BAN_FILE_STATE}/${bienBanData.id}`, null, {});
            setFilePathAbsolute('');
            setDownloadUrl('');
            setSignedFields([]);
            setBienBanUrl('');
            setNumPages(0);
            setOpenPdfViewer(false);
            queryClient.invalidateQueries(['cmeBienBan', eventData?.id]);
            toast.success('Đã reset file biên bản.');
        } catch (error) {
            toast.error(error?.message || 'Lỗi khi reset file biên bản.');
        } finally {
            setIsResettingFile(false);
        }
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2 text-muted">Đang tải biên bản...</div>
            </div>
        );
    }

    return (
        <div className="px-1 py-3">
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white py-3">
                    <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: '8px' }}>
                        <span className="font-weight-bold text-dark" style={{ fontSize: '0.95rem' }}>
                            <i className="fas fa-file-signature mr-2 text-primary"></i>Xuất và ký số biên bản
                        </span>
                        {bienBanUrl && (
                            <Badge variant="success" className="px-2 py-1">
                                <i className="fas fa-check-circle mr-1"></i>Đã lấy PDF ký số
                            </Badge>
                        )}
                    </div>
                </div>
                <div className="card-body bg-light">
                    <Row className="align-items-end">
                        <Col lg={5} className="mb-3 mb-lg-0">
                            <Form.Label className="font-weight-bold small text-muted">FILE MẪU DOCX</Form.Label>
                            <AsyncPaginate
                                name="bienBanDocxFileId"
                                id="bienBanDocxFileId"
                                placeholder="Chọn file docx"
                                value={docxFileId}
                                loadOptions={loadOptionsDocxFile}
                                styles={styleSelectDefault}
                                isClearable
                                onChange={(selectedOption) => {
                                    setDocxFileId(selectedOption);
                                    setDocxFilePath(selectedOption?.label || '');
                                }}
                                additional={{ page: 1 }}
                            />
                        </Col>
                        <Col lg={7}>
                            <div className="d-flex flex-wrap justify-content-lg-end align-items-center" style={{ gap: '8px' }}>
                                <Button size="sm" variant="primary" onClick={handleExportBienBan} disabled={isExporting}>
                                    {isExporting
                                        ? <><Spinner animation="border" size="sm" className="mr-1" />Đang xuất...</>
                                        : <><i className="fas fa-file-word mr-1"></i>Xuất biên bản</>}
                                </Button>
                                <Button size="sm" variant="outline-danger" onClick={() => setOpenPdfViewer(true)} disabled={!filePathAbsolute && !downloadUrl}>
                                    <i className="fas fa-eye mr-1"></i>Xem lại file
                                </Button>
                                <Button size="sm" variant="danger" onClick={handleOpenSignModal} disabled={!filePathAbsolute}>
                                    <i className="fas fa-signature mr-1"></i>Login để ký số
                                </Button>
                                <Button size="sm" variant="outline-danger" onClick={handleResetBienBanFile} disabled={isResettingFile || (!filePathAbsolute && !downloadUrl && !bienBanUrl && signedFields.length === 0)}>
                                    {isResettingFile
                                        ? <Spinner animation="border" size="sm" />
                                        : <><i className="fas fa-redo mr-1"></i>Reset file</>}
                                </Button>
                                <Button
                                    size="sm"
                                    variant={bienBanUrl ? 'success' : 'outline-primary'}
                                    onClick={handleUploadBienBan}
                                    disabled={!downloadUrl || !hasAllRequiredSignatures || isUploadingFile}
                                >
                                    {isUploadingFile
                                        ? <Spinner animation="border" size="sm" />
                                        : <><i className="fas fa-file-pdf mr-1"></i>{bienBanUrl ? 'Đã đính kèm' : 'Lấy PDF đã ký'}</>}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    <small className="d-block text-muted mt-3">
                        Chọn mẫu DOCX, xuất phụ lục, ký đủ các vị trí bắt buộc rồi lấy PDF đã ký để hoàn tất hồ sơ.
                    </small>
                </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4 p-3 border rounded bg-light shadow-sm">
                <div>
                    <h6 className="font-weight-bold mb-1 text-primary text-uppercase" style={{ letterSpacing: '0.5px' }}>
                        Biên bản sinh hoạt khoa học chuyên môn điều dưỡng
                    </h6>
                    <small className="text-muted"><i className="fas fa-graduation-cap mr-1"></i>{eventData?.tenKhoaDaoTao}</small>
                </div>
                <div className="d-flex align-items-center">
                    <span className="mr-3 font-weight-bold" style={{ fontSize: '0.85rem' }}>
                        Trạng thái biên bản: 
                        <Badge variant={trangThaiInfo.variant} className="ml-2 px-2 py-1" style={{ fontSize: '0.8rem' }}>
                            {trangThaiInfo.label}
                        </Badge>
                    </span>
                    <Button
                        variant="outline-primary"
                        size="sm"
                        className="mr-2"
                        disabled={saveMutation.isLoading}
                        onClick={() => handleSave(0)}
                    >
                        {saveMutation.isLoading ? <Spinner animation="border" size="sm" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu nháp
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        disabled={saveMutation.isLoading}
                        onClick={() => handleSave(1)}
                    >
                        {saveMutation.isLoading ? <Spinner animation="border" size="sm" /> : <i className="fas fa-check mr-1"></i>}
                        Hoàn thành
                    </Button>
                </div>
            </div>

            {/* Form chi tiết */}
            <Form>
                {/* SECTION 1 */}
                <CardSection title="Thông tin chung" icon="fas fa-info-circle">
                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Thời gian bắt đầu <span className="text-danger">*</span></Form.Label>
                                <div className="d-block">
                                    <DatePicker
                                        selected={thoiGianBatDau ? moment(thoiGianBatDau).toDate() : null}
                                        onChange={date => setThoiGianBatDau(date ? moment(date).format('YYYY-MM-DDTHH:mm') : '')}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={5}
                                        timeCaption="Giờ"
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        className="form-control"
                                        placeholderText="Chọn thời gian bắt đầu..."
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Thời gian kết thúc</Form.Label>
                                <div className="d-block">
                                    <DatePicker
                                        selected={thoiGianKetThuc ? moment(thoiGianKetThuc).toDate() : null}
                                        onChange={date => setThoiGianKetThuc(date ? moment(date).format('YYYY-MM-DDTHH:mm') : '')}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={5}
                                        timeCaption="Giờ"
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        className="form-control"
                                        placeholderText="Chọn thời gian kết thúc..."
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Thư ký</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Họ tên thư ký..."
                                    value={thuKy}
                                    onChange={e => setThuKy(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Địa điểm <Badge variant="info" className="ml-1" style={{ fontSize: '0.6rem' }}>Có thể sửa</Badge></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={diaDiem}
                                    onChange={e => setDiaDiem(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Chủ trì <Badge variant="info" className="ml-1" style={{ fontSize: '0.6rem' }}>Có thể sửa</Badge></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={chuTri}
                                    onChange={e => setChuTri(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Thành phần tham gia</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Danh sách khoa phòng tham gia..."
                                    value={thanhPhan}
                                    onChange={e => setThanhPhan(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </CardSection>

                {/* SECTION 2 */}
                <CardSection title="Nội dung tiến hành" icon="fas fa-file-medical">
                    <Row>
                        <Col md={8}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Tên bài báo cáo <Badge variant="info" className="ml-1" style={{ fontSize: '0.6rem' }}>Có thể sửa</Badge></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={tenBaoCao}
                                    onChange={e => setTenBaoCao(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Người báo cáo <Badge variant="info" className="ml-1" style={{ fontSize: '0.6rem' }}>Có thể sửa</Badge></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={baoCaoVien}
                                    onChange={e => setBaoCaoVien(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </CardSection>

                {/* SECTION 3 */}
                <div className="card shadow-sm border-0 mb-4">
                    <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                        <span className="font-weight-bold text-dark" style={{ fontSize: '0.95rem' }}>
                            <i className="fas fa-comments mr-2 text-primary"></i>Thảo luận – Ý kiến đóng góp
                        </span>
                        <Button variant="outline-success" size="sm" onClick={addYKien} className="py-1">
                            <i className="fas fa-plus mr-1"></i>Thêm ý kiến
                        </Button>
                    </div>
                    <div className="card-body bg-light">
                        {yKiens.map((yk, idx) => (
                            <div key={idx} className="bg-white border rounded p-3 mb-2 shadow-sm">
                                <Row className="align-items-center">
                                    <Col md={1} className="text-center font-weight-bold text-secondary">
                                        #{idx + 1}
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-0">
                                            <Form.Label className="font-weight-bold mb-1" style={{ fontSize: '0.8rem' }}>Người phát biểu</Form.Label>
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                placeholder="Tên, chức vụ..."
                                                value={yk.nguoiDongGop}
                                                onChange={e => updateYKien(idx, 'nguoiDongGop', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-0">
                                            <Form.Label className="font-weight-bold mb-1" style={{ fontSize: '0.8rem' }}>Nội dung ý kiến</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={1}
                                                size="sm"
                                                placeholder="Nội dung thảo luận..."
                                                value={yk.noiDung}
                                                onChange={e => updateYKien(idx, 'noiDung', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={1} className="text-right">
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            disabled={yKiens.length <= 1}
                                            onClick={() => removeYKien(idx)}
                                        >
                                            <i className="fas fa-trash-alt"></i>
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>
                </div>

                {/* SECTION 4 */}
                <CardSection title="Kết luận của chủ trì" icon="fas fa-gavel">
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Nội dung thống nhất</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Các điểm thống nhất chuyên môn..."
                                    value={ketLuanThongNhat}
                                    onChange={e => setKetLuanThongNhat(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="font-weight-bold">Nội dung cần triển khai</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Phân công công việc tiếp theo..."
                                    value={ketLuanTrienKhai}
                                    onChange={e => setKetLuanTrienKhai(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </CardSection>
            </Form>

            <Modal show={openSignModal} onHide={() => setOpenSignModal(false)} centered backdrop="static" style={{ zIndex: 999999 }}>
                <Modal.Header closeButton>
                    <Modal.Title>Ký số biên bản</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>File biên bản</Form.Label>
                        <Form.Control value={getFileName(filePathAbsolute)} disabled />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Username</Form.Label>
                        <Form.Control value={bulkUsername} onChange={e => setBulkUsername(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" value={bulkPassword} onChange={e => setBulkPassword(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Loại ký</Form.Label>
                        <Form.Control as="select" value={bulkLoaiKy} onChange={e => setBulkLoaiKy(e.target.value)}>
                            {objectLoaiKy.map(item => <option key={item.value} value={item.value}>{item.text}</option>)}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Chức vụ ký</Form.Label>
                        <Form.Control as="select" value={bulkChuKy} onChange={e => setBulkChuKy(e.target.value)}>
                            {objectChuKyBienBan.map(item => (
                                <option key={item.value} value={item.value} disabled={signedFields.includes(item.value)}>
                                    {item.text}{signedFields.includes(item.value) ? ' - Đã ký' : ''}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSign} disabled={isSigning}>
                        {isSigning ? <><Spinner animation="border" size="sm" className="mr-2" />Đang ký...</> : 'Xác nhận'}
                    </Button>
                    <Button variant="secondary" onClick={() => setOpenSignModal(false)} disabled={isSigning}>Hủy</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={openPdfViewer} onHide={() => setOpenPdfViewer(false)} size="xl" centered backdrop="static" style={{ zIndex: 999999 }}>
                <Modal.Header closeButton>
                    <Modal.Title>Xem file PDF biên bản đã ký</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '75vh', overflow: 'auto', padding: 16, backgroundColor: '#f8f9fa' }}>
                    <div style={{ minWidth: 1100, display: 'flex', justifyContent: 'center' }}>
                        <Document
                            file={resolvePdfUrl(downloadUrl || getRelativeFilePath(filePathAbsolute))}
                            onLoadSuccess={({ numPages: totalPages }) => setNumPages(totalPages)}
                            loading="Đang tải PDF..."
                            error="Không tải được PDF"
                        >
                            {Array.from({ length: numPages }, (_, index) => (
                                <Page
                                    key={`bien_ban_page_${index + 1}`}
                                    pageNumber={index + 1}
                                    width={1050}
                                    renderAnnotationLayer={false}
                                    renderTextLayer={false}
                                />
                            ))}
                        </Document>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenPdfViewer(false)}>Đóng</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

// UI helper section wrapper
const CardSection = ({ title, icon, children }) => (
    <div className="card shadow-sm border-0 mb-4">
        <div className="card-header bg-white py-3 border-bottom-0">
            <span className="font-weight-bold text-dark" style={{ fontSize: '0.95rem' }}>
                <i className={`${icon} mr-2 text-primary`}></i>{title}
            </span>
        </div>
        <div className="card-body pt-0">{children}</div>
    </div>
);

export default CMEBienBanFormTab;
